import { render, staticRenderFns } from "./TotalSocialInteractionsChart.vue?vue&type=template&id=465c2196"
import script from "./TotalSocialInteractionsChart.vue?vue&type=script&lang=ts"
export * from "./TotalSocialInteractionsChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports